import * as Api from '../api/printNTS'
import { templateGetting } from '@/api/common.js'
const state = {
  printList: [],
  templateList: []
}
const mutations = {
  SET_PRINT_OBJ(state, value) {
    state.printList = value
  },
  GET_TEMPLATE_LIST(state, value) {
    state.templateList = value
  }
}
const actions = {
  getTemplateList({ commit }, id) {
    return templateGetting(id).then(res => {
      let admissObj = {}
      let scoreObj = {}
      let dataList = []
      if (res && res.length) {
        res.forEach(item => {
          if (item.propertyModule === 'AdmissionTicket') {
            admissObj[item.propertyKey] = item.propertyValue
          } else {
            scoreObj[item.propertyKey] = item.propertyValue
          }
        })
        if (Object.keys(admissObj).length) {
          admissObj['type'] = 'AdmissionTicket'
          dataList.push(admissObj)
        } else if (Object.keys(scoreObj).length) {
          scoreObj['type'] = 'Certification'
          dataList.push(scoreObj)
        }
      }
      commit('GET_TEMPLATE_LIST', dataList)
      return res
    })
  }
}
export default {
  state,
  mutations,
  actions
}
